import React, { useEffect, useState } from 'react';
import SplashScreen from '../SplashScreen'; 

const withSplash = (WrappedComponent, delay = 2000) => {
  return (props) => {
    const [showSplash, setShowSplash] = useState(true);

    useEffect(() => {
      const timer = setTimeout(() => {
        setShowSplash(false);
      }, delay); // Adjust timeout as needed

      return () => clearTimeout(timer);
    }, [delay]);

    return showSplash ? <SplashScreen /> : <WrappedComponent {...props} />;
  };
};

export default withSplash;
